import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => {
	const $quoteSym = "";

	return {
		navbarContainer: {
			backgroundColor : theme.other.colors.background.tertiary,
			padding         : props?.deviceViewTab ? "0 20px" : "0 200px",
			display         : "flex",
			alignItems      : "center",
			justifyContent  : "space-between"
		},
		dotsIcon: {
			width        : "30px",
			height       : "30px",
			cursor       : "pointer",
			marginLeft   : "1rem",
			background   : props?.open ? theme.other.colors.background2.primary : "",
			borderRadius : props?.open ? "100%" : "",

			"&:hover": {
				backgroundColor : theme.other.colors.background2.primary,
				borderRadius    : "100%"
			}
		},
		svgIcon: {
			...theme.other.svgIcons.size20
		},
		appearenceContainer: {
			display        : "flex",
			justifyContent : "space-between",
			padding        : "1rem 1.5rem",
			background     : theme.other.darkMode ? `${ theme.other.paletteNew.darkModeInclinedBlack2 } !important` : `${ theme.other.paletteNew.secondaryWhite } !important`
		},
		appearenceSubContainer: {
			display    : "flex",
			alignItems : "center"
		},
		rooterButton: {
			display         : "flex",
			alignItems      : "center",
			borderRadius    : "1rem",
			padding         : "0.5rem 1.5rem",
			backgroundImage : "linear-gradient(to bottom, #126bd5, #439aff)",
			width           : "max-content"
		},
		linkColor: {
			color    : "#fff",
			fontSize : "1.4rem"
		},
		endSection: {
			display: "flex"
		},
		middleSection: {
			display        : "flex",
			alignItems     : "center",
			width          : "100%",
			justifyContent : props?.deviceViewTab ? "flex-end" : "center",
			padding        : props?.deviceViewTab ? "1rem 0" : "",
			marginRight    : props?.deviceViewTab ? "2rem" : ""
		},
		startSection: {
			display    : "flex",
			alignItems : "center",
			cursor     : "pointer"
		},
		rooterLogo: {
			width  : "30px",
			height : "30px"
		},
		blogText: {
			fontSize   : "2rem",
			fontWeight : "800",
			marginLeft : "0.5rem",
			fontFamily : "\"Helvetica\",\"Arial\",sans-serif"
		},
		categoryName: {
			padding : props?.showDropDown ? "0" : "0 2rem",
			cursor  : "pointer"
		},
		categoriesButton: {
			display       : "flex",
			flexDirection : "row",
			gap           : "0.5rem",
			position      : "relative",
			color         : theme.other.colors.text.primary,
			border        : "none",
			padding       : "1rem 1.5rem",
			borderRadius  : "10px",
			fontWeight    : "500",
			fontsize      : "1.2rem",
			cursor        : "pointer",
			background    : props?.showDropDown ? theme.other.colors.background2.primary : "inherit"
		},
		categoriesMenu: {
			backgroundColor : theme.other.colors.background.tertiary,
			position        : "absolute",
			top             : "40px",
			left            : "0",
			borderRadius    : "10px",
			boxShadow       : "0 0 8px 2px rgba(255, 255, 255, 0.14)",
			width           : "14rem",
			display         : "flex",
			flexDirection   : "column",
			justifyContent  : "flex-start",
			padding         : "1rem 1.5rem",
			gap             : "1.5rem",
			border          : `1px solid ${ theme.other.colors.border.primary }`
		},
		tab: {
			padding      : "0 0 0 0",
			display      : "flex",
			marginBottom : "0.5rem"
		},
		tab2: {
			padding: "2rem 0",

			"&.active": {
				position  : "relative",
				"&:after" : {
					content              : `'${ $quoteSym }'`,
					position             : "absolute",
					bottom               : "0",
					left                 : "0%",
					width                : "100%",
					borderTopLeftRadius  : "2px",
					borderTopRightRadius : "2px",
					background           : theme.other.paletteNew.primaryDarkBlue,
					height               : "3px",
					zindex               : -1
				}
			}
		},
		item: {
			padding: "0.6rem 0"
		},
		itemLabel: {
			padding: "0"
		},
		mainMenuContainer: {
			maxWidth     : "230px",
			minWidth     : "180px",
			border       : "none",
			background   : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryWhite,
			borderRadius : "1rem",
			padding      : "0",
			overflow     : "hidden",
			boxShadow    : theme.other.colors.boxShadow.primary
		}

	};
} );
